import { Button } from "components/Button/Button";
import { ActionDropdownButton } from "components/DropdownButton/ActionDropdownButton";
import ElementLoader from "components/ElementLoader";
import { IconLike } from "components/Icon/Icon";

interface SaveSplitButtonProps {
    canCommit: boolean;
    icon?: IconLike;
    isDisabled: boolean;
    // Spins + self-disables the split Save button while a save is running.
    isLoading: boolean;
    // Additionally disables (without spinning) while any other form action runs.
    isBusy?: boolean;
    saveFormWithCommit: (canCommit: boolean) => void;
    overlayClassName?: string;
}

export const SaveSplitButton = ({
    canCommit,
    icon,
    isDisabled,
    isLoading,
    isBusy,
    saveFormWithCommit,
    overlayClassName,
}: SaveSplitButtonProps) => {
    const getProps = (canCommit) => ({
        action: () => saveFormWithCommit(canCommit),
        label: canCommit ? "Save and commit" : "Save",
    });
    const parentProps = getProps(canCommit);
    const childProps = getProps(!canCommit);

    // Replace the icon with the spinner while saving, keeping the label — the
    // same treatment as the Commit button. (see ui-design-principle-buttons)
    const loadingIcon = isLoading
        ? () => (
              <div className="actionButtonLoader">
                  <ElementLoader />
              </div>
          )
        : null;

    return (
        <ActionDropdownButton
            icon={loadingIcon ?? icon}
            isLoading={isLoading}
            isDisabled={isDisabled || isLoading || isBusy}
            parentAction={parentProps.action}
            label={parentProps.label}
            overlayClassName={overlayClassName}
            tooltipOverlay="Ctrl+S"
        >
            <Button
                icon={icon}
                variation="clear"
                className="wide"
                disabled={isDisabled || isLoading || isBusy}
                onClick={childProps.action}
                label={childProps.label}
            />
        </ActionDropdownButton>
    );
};
